<div class="header"></div>

<div class="container mt-4 mb-5" id="mainContent">
  <h2 class="mb-3">Mis Autorizaciones</h2>
  <p class="lead" style="font-size: 18px;">Al completar el formulario, estarás iniciando una solicitud de autorización.
    Recibirás una respuesta por correo electrónico en un plazo de hasta 72 horas hábiles.</p>

  <form [formGroup]="authForm" (ngSubmit)="enviarSolicitud()" (keydown)="manejarEnterComoTab($event)">
    <h3 class="section-title">Datos personales</h3>

    <div class="row mb-3">
      <div class="col-md-6 mb-3 mb-md-0">
        <label for="tipoDocumento" class="form-label">Tipo Documento
          <label class="text-danger">*</label>
        </label>
        <select class="form-select" id="tipoDocumento" formControlName="tipoDocumento"
          [ngClass]="{'is-invalid': isInvalid('tipoDocumento')}">

          <option value="DNI" selected>DNI</option>
          <option value="CUIT">CUIT</option>
          <option value="CUIL">CUIL</option>
          <option value="PASAPORTE">PASAPORTE</option>
        </select>
        @if (isInvalid('tipoDocumento')) {
        <div class="text-danger-obligatorio">Este campo es obligatorio</div>
        }
      </div>
      <div class="col-md-6">
        <label for="dni" class="form-label">Número Documento
          <label class="text-danger">*</label>
        </label>
        <input type="text" class="form-control" id="dni" formControlName="dni"
          [ngClass]="{'is-invalid': isInvalid('dni')}" (blur)="buscarAfiliado()">
        <div class="form-text">Número que figura en el pedido médico</div>
        @if (isInvalid('dni')) {
        <div class="text-danger-obligatorio">{{ getDocumentNumberErrorMessage() }}</div>
        }
      </div>
    </div>

    <!-- Apellido y nombre en fila -->
    <div class="row mb-3">
      <div class="col-md-6 mb-3 mb-md-0">
        <label for="apellido" class="form-label">Apellido <label class="text-danger">*</label></label>
        <input type="text" class="form-control" id="apellido" formControlName="apellido"
          [ngClass]="{'is-invalid': isInvalid('apellido')}" readonly>
        <div class="form-text">Apellido que figura en el pedido médico</div>
        @if (isInvalid('apellido')) {
        <div class="text-danger-obligatorio">Este campo es obligatorio</div>
        }
      </div>
      <div class="col-md-6">
        <label for="nombre" class="form-label">Nombre
          <label class="text-danger">*</label>
        </label>
        <input type="text" class="form-control" id="nombre" formControlName="nombre"
          [ngClass]="{'is-invalid': isInvalid('nombre')}" readonly>
        <div class="form-text">Nombre que figura en el pedido médico</div>
        @if (isInvalid('nombre')) {
        <div class="text-danger-obligatorio">Este campo es obligatorio</div>
        }
      </div>
    </div>

    <div class="row mb-3">
      <div class="col-md-6 mb-3 mb-md-0">
        <label for="email" class="form-label">Tu E-mail
          <label class="text-danger">*</label>
        </label>
        <input type="email" class="form-control" id="email" formControlName="email"
          [ngClass]="{'is-invalid': isInvalid('email')}" placeholder="ejemplo@gmail.com">
        <div class="form-text">(recordá que nos comunicaremos a esta casilla)</div>
        @if (isInvalid('email')) {
        <div class="text-danger-obligatorio">
          @if (authForm.get('email')?.hasError('required')) {
          Este campo es obligatorio
          } @else if (authForm.get('email')?.hasError('email')) {
          Por favor ingrese un correo electrónico válido
          }
        </div>
        }
      </div>

      <div class="col-md-6">
        <label for="telefono" class="form-label">Número de teléfono
          <label class="text-danger">*</label>
        </label>
        <div class="row">
          <div class="col-4 col-sm-3">
            <input type="text" class="form-control" id="codigoArea" formControlName="codigoArea"
              [ngClass]="{'is-invalid': isInvalid('codigoArea')}" placeholder="351">
            <div class="form-text">Código de área</div>
            @if (isInvalid('codigoArea')) {
            <div class="text-danger-obligatorio">Obligatorio</div>
            }
          </div>
          <div class="col-auto pt-2">-</div>
          <div class="col-7 col-sm-8">
            <input type="text" class="form-control" id="numeroTelefono" formControlName="numeroTelefono"
              [ngClass]="{'is-invalid': isInvalid('numeroTelefono')}" placeholder="4670438">
            <div class="form-text">Número de teléfono</div>
            @if (isInvalid('numeroTelefono')) {
            <div class="text-danger-obligatorio">{{ getNumeroTelefonoErrorMessage() }}</div>
            }
          </div>
        </div>
      </div>
    </div>

    <h3 class="section-title">Datos para solicitar la Autorización</h3>

    <div class="mb-3">
      <label for="tipoAutorizacion" class="form-label">¿Qué necesitás autorizar?</label>
      <select class="form-select" id="tipoAutorizacion" formControlName="tipoAutorizacion"
        [ngClass]="{'is-invalid': isInvalid('tipoAutorizacion')}" (change)="onTipoChange($event)">
        <option value="" selected>Seleccione</option>
        @for (autorizacion of autorizaciones; track autorizacion.id) {
        <option [value]="autorizacion.id">{{ autorizacion.tipoAutorizacion }}</option>
        }
        <!-- <option value="oxigeno">Oxígeno en domicilio</option>-->
      </select>
      <div class="form-text">Recordá que podés iniciar una solicitud adjuntando varios pedidos médicos o recetas</div>
      @if (isInvalid('tipoAutorizacion')) {
      <div class="text-danger-obligatorio">Por favor seleccione qué necesita autorizar</div>
      }
    </div>

    <!-- Sección condicional que cambia según la selección -->
    @switch (tipoSeleccionado()) {
    @case (1) {
    <div class="mt-4 border rounded p-3 bg-light">
      <h4>Datos de Medicación</h4>

      <!-- Diagnóstico -->
      <div class="mb-3">
        <label for="diagnosticoMed" class="form-label">Diagnóstico <span class="text-danger">*</span></label>
        <input type="text" class="form-control" id="diagnosticoMed" formControlName="diagnosticoMed"
          [ngClass]="{'is-invalid': isInvalid('diagnosticoMed')}">
        <div class="form-text">Debe coincidir con lo detallado en el pedido.</div>
        @if (isInvalid('diagnosticoMed')) {
        <div class="text-danger-obligatorio">Este campo es obligatorio</div>
        }
      </div>

      <!-- Primera vez que prescriben -->
      <div class="mb-3">
        <label class="form-label">¿Primera vez que prescriben esta medicación? <span
            class="text-danger">*</span></label>
        <div [ngClass]="{'is-invalid': isInvalid('prescripMedicPrim')}">
          <div class="form-check">
            <input class="form-check-input" type="radio" formControlName="prescripMedicPrim" id="prescripcionSi"
              value="SI">
            <label class="form-check-label" for="prescripcionSi">Sí</label>
          </div>
          <div class="form-check">
            <input class="form-check-input" type="radio" formControlName="prescripMedicPrim" id="prescripcionNo"
              value="NO">
            <label class="form-check-label" for="prescripcionNo">No</label>
          </div>
          <div class="form-check">
            <input class="form-check-input" type="radio" formControlName="prescripMedicPrim" id="prescripcionNoRecuerdo"
              value="NO RECUERDO">
            <label class="form-check-label" for="prescripcionNoRecuerdo">No recuerdo</label>
          </div>
        </div>
        @if (isInvalid('prescripMedicPrim')) {
        <div class="text-danger-obligatorio">Por favor seleccione una opción</div>
        }
      </div>

      <!-- Farmacia -->
      <div class="mb-3">
        <label for="farmacia" class="form-label">¿Para qué farmacia se solicita el pedido? <span
            class="text-danger">*</span></label>
        <select class="form-select" id="farmacia" formControlName="farmacia"
          [ngClass]="{'is-invalid': isInvalid('farmacia')}">
          <option value="" selected>Seleccione</option>
          @for (farmacia of farmacias; track farmacia.id) {
          <option [value]="farmacia.id">{{ (farmacia.nombre === 'FARMACITY' ? farmacia.nombre : farmacia.sucursal) }} - Loc: {{ farmacia.localidad }}</option>
          }
        </select>
        <div class="form-text">El listado se encuentra ordenado alfabéticamente por la localidad donde se encuentra la
          farmacia junto a su dirección.</div>
        @if (isInvalid('farmacia')) {
        <div class="text-danger-obligatorio">Por favor seleccione una farmacia</div>
        }
      </div>

      <div class="text-center">
        <img src="https://www.jotform.com/uploads/GEAInfo/form_files/4.66b0db1306c318.97196732.jpg"
          class="img-fluid w-75" alt="Imagen">
      </div>

      <!-- Subir archivos -->
      <div class="mb-3">
        <label class="form-label">Adjunta las recetas para medicación <span class="text-danger">*</span></label>
        <div class="d-flex" [ngClass]="{'is-invalid': isInvalid('recetasFiles')}">
          <!-- Input oculto para selección de archivos -->
          <input #recetasFilesInput type="file" class="custom-file-input" id="recetasFiles"
            (change)="onFileSelected($event, 'recetasFiles')" multiple accept=".pdf,.jpg,.jpeg,.png">

          <!-- Botón personalizado que activa el input oculto -->
          <label for="recetasFiles" class="custom-file-button">
            <i class="bi bi-cloud-upload me-2"></i>Adjuntar archivos
          </label>
        </div>

        <div class="form-text">Podés adjuntar todos los archivos juntos en formato PDF, JPG, PNG</div>
        @if (isInvalid('recetasFiles')) {
        <div class="text-danger-obligatorio">Debe adjuntar al menos un archivo</div>
        }

        <!-- Lista de archivos seleccionados -->
        @if (selectedFiles.recetasFiles.length > 0) {
        <div class="selected-files-card">
          <div class="selected-files-header">
            <small>Archivos seleccionados ({{selectedFiles.recetasFiles.length}})</small>
          </div>
          <div>
            @for (file of selectedFiles.recetasFiles; track file; let i = $index) {
            <div class="file-item">
              <div class="file-info">
                <i class="{{getFileIcon(file.name)}} file-icon"></i>
                <span>{{file.name}} <small class="text-muted">({{formatFileSize(file.size)}})</small></span>
              </div>
              <button type="button" class="btn-delete-file" (click)="eliminarArchivo('recetasFiles', i)"
                title="Eliminar archivo" style="font-size: 0.7rem; padding: 2px 5px;">
                <i class="bi bi-trash"></i>
              </button>
            </div>
            }
          </div>
        </div>
        }
      </div>

      <!-- Observaciones -->
      <div class="mb-3">
        <label for="observacionesMed" class="form-label">Observaciones</label>
        <textarea class="form-control" id="observacionesMed" formControlName="observacionesMed" rows="3"></textarea>
        <div class="form-text">Si lo consideras necesario, podes registrar tus comentarios aquí</div>
      </div>
    </div>
    }
    @case (2) {
    <div class="mt-4 border rounded p-3 bg-light">
      <h4>Datos de Estudios y/o Prácticas</h4>

      <!-- Diagnóstico -->
      <div class="mb-3">
        <label for="diagnosticoEst" class="form-label">Diagnóstico <span class="text-danger">*</span></label>
        <input type="text" class="form-control" id="diagnosticoEst" formControlName="diagnosticoEst"
          [ngClass]="{'is-invalid': isInvalid('diagnosticoEst')}">
        <div class="form-text">Debe coincidir con lo detallado en el pedido.</div>
        @if (isInvalid('diagnosticoEst')) {
        <div class="text-danger-obligatorio">Este campo es obligatorio</div>
        }
      </div>

      <!-- Tiene turno asignado -->
      <div class="mb-3">
        <label class="form-label">¿Tiene turno asignado o fecha probable de práctica? <span
            class="text-danger">*</span></label>
        <div [ngClass]="{'is-invalid': isInvalid('tieneTurno')}">
          <div class="form-check">
            <input class="form-check-input" type="radio" formControlName="tieneTurno" id="turnoSi" value="S"
              (change)="onTurnoChange($event)">
            <label class="form-check-label" for="turnoSi">Sí</label>
          </div>
          <div class="form-check">
            <input class="form-check-input" type="radio" formControlName="tieneTurno" id="turnoNo" value="N"
              (change)="onTurnoChange($event)">
            <label class="form-check-label" for="turnoNo">No</label>
          </div>
        </div>
        @if (isInvalid('tieneTurno')) {
        <div class="text-danger-obligatorio">Por favor seleccione una opción</div>
        }
      </div>

      <!-- Fecha del turno (condicional) -->
      @if (authForm.get('tieneTurno')?.value === 'S') {
      <div class="mb-3" id="fechaTurnoContainer">
        <label for="fechaTurno" class="form-label">Fecha del turno <span class="text-danger">*</span></label>
        <input type="date" class="form-control" id="fechaTurno" formControlName="fechaTurno" [min]="fechaMinima"
          [ngClass]="{'is-invalid': isInvalid('fechaTurno')}">
        @if (isInvalid('fechaTurno')) {
        <div class="text-danger-obligatorio">{{ getFechaTurnoErrorMessage('fechaTurno') }}</div>
        }
      </div>
      }

      <!-- Institución -->
      <div class="mb-3">
        <label for="institucion" class="form-label">¿Para qué institución solicita la autorización? <span
            class="text-danger">*</span></label>
        <select class="form-select" id="institucion" formControlName="institucion"
          [ngClass]="{'is-invalid': isInvalid('institucion')}">
          <option value="" selected>Seleccione</option>
          @for (institucion of instituciones; track institucion.id) {
          <option [value]="institucion.id">{{ institucion.apellidoRazonSocial }} - Loc: {{ institucion.localidad }}
          </option>
          }
        </select>
        <div class="form-text p-1">El listado se encuentra ordenado alfabéticamente por la localidad donde se encuentra
          el
          centro de atención</div>
        <div class="bg-opacity-50 bg-warning form-text text-warning-emphasis p-1 rounded">En caso de no encontrar a tu
          prestador
          dentro del listado, seleccioná la opción de 'Indefinido'. Podés escribir su nombre al final del formulario en
          el
          campo 'Observaciones'</div>
        @if (isInvalid('institucion')) {
        <div class="text-danger-obligatorio">Por favor seleccione una institución</div>
        }
      </div>

      <div class="text-center">
        <img src="https://www.jotform.com/uploads/GEAInfo/form_files/5.66b0db22799a09.77573672.jpg"
          class="img-fluid w-75" alt="Imagen">
      </div>

      <!-- Subir archivos -->
      <div class="mb-3">
        <label class="form-label">Adjuntar los pedidos médicos para prácticas o estudios <span
            class="text-danger">*</span></label>
        <div class="d-flex" [ngClass]="{'is-invalid': isInvalid('pedidosEstFiles')}">
          <!-- Input oculto para selección de archivos -->
          <input #pedidosEstFilesInput type="file" class="custom-file-input" id="pedidosEstFiles"
            (change)="onFileSelected($event, 'pedidosEstFiles')" multiple accept=".pdf,.jpg,.jpeg,.png">

          <!-- Botón personalizado que activa el input oculto -->
          <label for="pedidosEstFiles" class="custom-file-button">
            <i class="bi bi-cloud-upload me-2"></i>Adjuntar archivos
          </label>
        </div>

        <div class="form-text">Podés adjuntar todos los archivos juntos en formato PDF, JPG, PNG</div>
        @if (isInvalid('pedidosEstFiles')) {
        <div class="text-danger-obligatorio">Debe adjuntar al menos un archivo</div>
        }

        <!-- Lista de archivos seleccionados -->
        @if (selectedFiles.pedidosEstFiles.length > 0) {
        <div class="selected-files-card">
          <div class="selected-files-header">
            <small>Archivos seleccionados ({{selectedFiles.pedidosEstFiles.length}})</small>
          </div>
          <div>
            @for (file of selectedFiles.pedidosEstFiles; track file; let i = $index) {
            <div class="file-item">
              <div class="file-info">
                <i class="{{getFileIcon(file.name)}} file-icon"></i>
                <span>{{file.name}} <small class="text-muted">({{formatFileSize(file.size)}})</small></span>
              </div>
              <button type="button" class="btn-delete-file" (click)="eliminarArchivo('pedidosEstFiles', i)"
                title="Eliminar archivo" style="font-size: 0.7rem; padding: 2px 5px;">
                <i class="bi bi-trash"></i>
              </button>
            </div>
            }
          </div>
        </div>
        }
      </div>

      <!-- Observaciones -->
      <div class="mb-3">
        <label for="observacionesEst" class="form-label">Observaciones</label>
        <textarea class="form-control" id="observacionesEst" formControlName="observacionesEst" rows="3"></textarea>
        <div class="form-text">Si lo consideras necesario, podes registrar tus comentarios aquí</div>
      </div>
    </div>
    }
    @case (3) {
    <div class="mt-4 border rounded p-3 bg-light">
      <h4>Datos de Cirugía</h4>

      <!-- Diagnóstico -->
      <div class="mb-3">
        <label for="diagnosticoCir" class="form-label">Diagnóstico <span class="text-danger">*</span></label>
        <input type="text" class="form-control" id="diagnosticoCir" formControlName="diagnosticoCir"
          [ngClass]="{'is-invalid': isInvalid('diagnosticoCir')}">
        <div class="form-text">Debe coincidir con lo detallado en el pedido.</div>
        @if (isInvalid('diagnosticoCir')) {
        <div class="text-danger-obligatorio">Este campo es obligatorio</div>
        }
      </div>

      <!-- Necesita materiales/prótesis -->
      <div class="mb-3">
        <label class="form-label">¿Necesita materiales/prótesis para la cirugía? <span
            class="text-danger">*</span></label>
        <div [ngClass]="{'is-invalid': isInvalid('necesitaMateriales')}">
          <div class="form-check">
            <input class="form-check-input" type="radio" formControlName="necesitaMateriales" id="materialesSi"
              value="S" (change)="onNecesitaMaterialesChange($event)">
            <label class="form-check-label" for="materialesSi">Sí</label>
          </div>
          <div class="form-check">
            <input class="form-check-input" type="radio" formControlName="necesitaMateriales" id="materialesNo"
              value="N" (change)="onNecesitaMaterialesChange($event)">
            <label class="form-check-label" for="materialesNo">No</label>
          </div>
        </div>
        @if (isInvalid('necesitaMateriales')) {
        <div class="text-danger-obligatorio">Por favor seleccione una opción</div>
        }
      </div>

      <!-- Tiene turno asignado -->
      <div class="mb-3">
        <label class="form-label">¿Tiene turno asignado o fecha probable para la práctica? <span
            class="text-danger">*</span></label>
        <div [ngClass]="{'is-invalid': isInvalid('tieneTurnoCir')}">
          <div class="form-check">
            <input class="form-check-input" type="radio" formControlName="tieneTurnoCir" id="turnoCirSi" value="S"
              (change)="onTurnoCirChange($event)">
            <label class="form-check-label" for="turnoCirSi">Sí</label>
          </div>
          <div class="form-check">
            <input class="form-check-input" type="radio" formControlName="tieneTurnoCir" id="turnoCirNo" value="N"
              (change)="onTurnoCirChange($event)">
            <label class="form-check-label" for="turnoCirNo">No</label>
          </div>
        </div>
        @if (isInvalid('tieneTurnoCir')) {
        <div class="text-danger-obligatorio">Por favor seleccione una opción</div>
        }
      </div>

      <!-- Fecha del turno (condicional) -->
      @if (authForm.get('tieneTurnoCir')?.value === 'S') {
      <div class="mb-3" id="fechaTurnoCirContainer">
        <label for="fechaTurnoCir" class="form-label">Fecha del turno <span class="text-danger">*</span></label>
        <input type="date" class="form-control" id="fechaTurnoCir" formControlName="fechaTurnoCir" [min]="fechaMinima"
          [ngClass]="{'is-invalid': isInvalid('fechaTurnoCir')}">
        @if (isInvalid('fechaTurnoCir')) {
        <div class="text-danger-obligatorio">{{ getFechaTurnoErrorMessage('fechaTurnoCir') }}</div>
        }
      </div>
      }

      <!-- Institución -->
      <div class="mb-3">
        <label for="institucionCir" class="form-label">¿Para qué institución solicita la autorización? <span
            class="text-danger">*</span></label>
        <select class="form-select" id="institucionCir" formControlName="institucionCir"
          [ngClass]="{'is-invalid': isInvalid('institucionCir')}">
          <option value="" selected>Seleccione</option>
          @for (institucion of instituciones; track institucion.id) {
          <option [value]="institucion.id">{{ institucion.apellidoRazonSocial }} - Loc: {{ institucion.localidad }}
          </option>
          }
        </select>
        <div class="form-text ps-1">El listado se encuentra ordenado alfabéticamente por la localidad donde se encuentra el
          centro de atención</div>
        <div class="bg-opacity-50 bg-warning form-text text-warning-emphasis p-1 rounded">En caso de no encontrar a tu
          prestador
          dentro del listado, seleccioná la opción de 'Indefinido'. Podés escribir su nombre al final del formulario en
          el
          campo 'Observaciones'</div>
        @if (isInvalid('institucionCir')) {
        <div class="text-danger-obligatorio">Por favor seleccione una institución</div>
        }
      </div>
      <div class="text-center">
        <img src="https://www.jotform.com/uploads/GEAInfo/form_files/6.66b0db36b29f65.36073932.jpg"
          class="img-fluid w-75" alt="Imagen">
      </div>

      <!-- Pedido médico para cirugía -->
      <div class="mb-3">
        <label class="form-label">Adjuntá el pedido médico para Cirugía <span class="text-danger">*</span></label>
        <div class="d-flex" [ngClass]="{'is-invalid': isInvalid('pedidosCirFiles')}">
          <!-- Input oculto para selección de archivos -->
          <input #pedidosCirFilesInput type="file" class="custom-file-input" id="pedidosCirFiles"
            (change)="onFileSelected($event, 'pedidosCirFiles')" multiple accept=".pdf,.jpg,.jpeg,.png">

          <!-- Botón personalizado que activa el input oculto -->
          <label for="pedidosCirFiles" class="custom-file-button">
            <i class="bi bi-cloud-upload me-2"></i>Buscar archivos
          </label>
        </div>

        <div class="form-text">Podés adjuntar todos los archivos juntos en formato PDF, JPG, PNG</div>
        @if (isInvalid('pedidosCirFiles')) {
        <div class="text-danger-obligatorio">Debe adjuntar al menos un archivo</div>
        }

        <!-- Lista de archivos seleccionados -->
        @if (selectedFiles.pedidosCirFiles.length > 0) {
        <div class="selected-files-card">
          <div class="selected-files-header">
            <small>Archivos seleccionados ({{selectedFiles.pedidosCirFiles.length}})</small>
          </div>
          <div>
            @for (file of selectedFiles.pedidosCirFiles; track file; let i = $index) {
            <div class="file-item">
              <div class="file-info">
                <i class="{{getFileIcon(file.name)}} file-icon"></i>
                <span>{{file.name}} <small class="text-muted">({{formatFileSize(file.size)}})</small></span>
              </div>
              <button type="button" class="btn-delete-file" (click)="eliminarArchivo('pedidosCirFiles', i)"
                title="Eliminar archivo" style="font-size: 0.7rem; padding: 2px 5px;">
                <i class="bi bi-trash"></i>
              </button>
            </div>
            }
          </div>
        </div>
        }
      </div>

      <!-- Pedido médico de materiales/prótesis (solo se muestra si necesitaMateriales es S) -->
      @if (authForm.get('necesitaMateriales')?.value === 'S') {
      <div class="mb-3">
        <label class="form-label">Adjuntá pedido médico de materiales/prótesis para cirugía <span
            class="text-danger">*</span></label>
        <div class="d-flex" [ngClass]="{'is-invalid': isInvalid('pedidosMatFiles')}">
          <!-- Input oculto para selección de archivos -->
          <input #pedidosMatFilesInput type="file" class="custom-file-input" id="pedidosMatFiles"
            (change)="onFileSelected($event, 'pedidosMatFiles')" multiple accept=".pdf,.jpg,.jpeg,.png">

          <!-- Botón personalizado que activa el input oculto -->
          <label for="pedidosMatFiles" class="custom-file-button">
            <i class="bi bi-cloud-upload me-2"></i>Buscar archivos
          </label>
        </div>

        <div class="form-text">Podés adjuntar todos los archivos juntos en formato PDF, JPG, PNG</div>
        @if (isInvalid('pedidosMatFiles')) {
        <div class="text-danger-obligatorio">Debe adjuntar al menos un archivo</div>
        }

        <!-- Lista de archivos seleccionados -->
        @if (selectedFiles.pedidosMatFiles.length > 0) {
        <div class="selected-files-card">
          <div class="selected-files-header">
            <small>Archivos seleccionados ({{selectedFiles.pedidosMatFiles.length}})</small>
          </div>
          <div>
            @for (file of selectedFiles.pedidosMatFiles; track file; let i = $index) {
            <div class="file-item">
              <div class="file-info">
                <i class="{{getFileIcon(file.name)}} file-icon"></i>
                <span>{{file.name}} <small class="text-muted">({{formatFileSize(file.size)}})</small></span>
              </div>
              <button type="button" class="btn-delete-file" (click)="eliminarArchivo('pedidosMatFiles', i)"
                title="Eliminar archivo" style="font-size: 0.7rem; padding: 2px 5px;">
                <i class="bi bi-trash"></i>
              </button>
            </div>
            }
          </div>
        </div>
        }
      </div>
      }

      <!-- Estudios previos o informe médico -->
      <div class="mb-3">
        <label class="form-label">Adjuntá estudios previos o informe médico vinculado a la cirugía <span
            class="text-danger">*</span></label>
        <div class="d-flex" [ngClass]="{'is-invalid': isInvalid('estudiosCircFiles')}">
          <!-- Input oculto para selección de archivos -->
          <input #estudiosCircFilesInput type="file" class="custom-file-input" id="estudiosCircFiles"
            (change)="onFileSelected($event, 'estudiosCircFiles')" multiple accept=".pdf,.jpg,.jpeg,.png">

          <!-- Botón personalizado que activa el input oculto -->
          <label for="estudiosCircFiles" class="custom-file-button">
            <i class="bi bi-cloud-upload me-2"></i>Buscar archivos
          </label>
        </div>

        <div class="form-text">Podés adjuntar todos los archivos juntos en formato PDF, JPG, PNG</div>
        @if (isInvalid('estudiosCircFiles')) {
        <div class="text-danger-obligatorio">Debe adjuntar al menos un archivo</div>
        }

        <!-- Lista de archivos seleccionados -->
        @if (selectedFiles.estudiosCircFiles.length > 0) {
        <div class="selected-files-card">
          <div class="selected-files-header">
            <small>Archivos seleccionados ({{selectedFiles.estudiosCircFiles.length}})</small>
          </div>
          <div>
            @for (file of selectedFiles.estudiosCircFiles; track file; let i = $index) {
            <div class="file-item">
              <div class="file-info">
                <i class="{{getFileIcon(file.name)}} file-icon"></i>
                <span>{{file.name}} <small class="text-muted">({{formatFileSize(file.size)}})</small></span>
              </div>
              <button type="button" class="btn-delete-file" (click)="eliminarArchivo('estudiosCircFiles', i)"
                title="Eliminar archivo" style="font-size: 0.7rem; padding: 2px 5px;">
                <i class="bi bi-trash"></i>
              </button>
            </div>
            }
          </div>
        </div>
        }
      </div>

      <!-- Observaciones -->
      <div class="mb-3">
        <label for="observacionesCir" class="form-label">Observaciones</label>
        <textarea class="form-control" id="observacionesCir" formControlName="observacionesCir" rows="3"></textarea>
        <div class="form-text">Si lo consideras necesario, podes registrar tus comentarios aquí</div>
      </div>
    </div>
    }
    @case (4) {
    <div class="mt-4 border rounded p-3 bg-light">
      <h4>Datos de Oxígeno en Domicilio</h4>

      <!-- Diagnóstico -->
      <div class="mb-3">
        <label for="diagnosticoOxi" class="form-label">Diagnóstico <span class="text-danger">*</span></label>
        <input type="text" class="form-control" id="diagnosticoOxi" formControlName="diagnosticoOxi"
          [ngClass]="{'is-invalid': isInvalid('diagnosticoOxi')}">
        <div class="form-text">Debe coincidir con lo detallado en el pedido.</div>
        @if (isInvalid('diagnosticoOxi')) {
        <div class="text-danger-obligatorio">Este campo es obligatorio</div>
        }
      </div>

      <!-- Duración del tratamiento -->
      <div class="mb-3">
        <label for="duracionTratamiento" class="form-label">Duración del tratamiento <span
            class="text-danger">*</span></label>
        <select class="form-select" id="duracionTratamiento" formControlName="duracionTratamiento"
          [ngClass]="{'is-invalid': isInvalid('duracionTratamiento')}">
          <option value="">Seleccione</option>
          <option value="30DIAS">30 días</option>
          <option value="60DIAS">60 días</option>
          <option value="90DIAS">90 días</option>
          <option value="PERMANENTE">Permanente</option>
        </select>
        @if (isInvalid('duracionTratamiento')) {
        <div class="text-danger-obligatorio">Por favor seleccione la duración del tratamiento</div>
        }
      </div>

      <!-- Proveedor -->
      <div class="mb-3">
        <label for="proveedor" class="form-label">¿Para qué proveedor solicita la autorización? <span
            class="text-danger">*</span></label>
        <select class="form-select" id="proveedor" formControlName="proveedor"
          [ngClass]="{'is-invalid': isInvalid('proveedor')}">
          <option value="">Seleccione</option>
          <option value="1">Proveedor Oxígeno Córdoba - Córdoba Capital</option>
          <option value="2">Gas Médico SRL - Carlos Paz</option>
          <option value="3">Gases del Centro - Córdoba Capital</option>
        </select>
        <div class="form-text">El listado se encuentra ordenado alfabéticamente por la localidad</div>
        @if (isInvalid('proveedor')) {
        <div class="text-danger-obligatorio">Por favor seleccione un proveedor</div>
        }
      </div>

      <!-- Subir archivos -->
      <div class="mb-3">
        <label class="form-label">Pedido médico para oxígeno domiciliario <span class="text-danger">*</span></label>
        <div class="d-flex" [ngClass]="{'is-invalid': isInvalid('pedidosOxiFiles')}">
          <!-- Input oculto para selección de archivos -->
          <input #pedidosOxiFilesInput type="file" class="custom-file-input" id="pedidosOxiFiles"
            (change)="onFileSelected($event, 'pedidosOxiFiles')" multiple accept=".pdf,.jpg,.jpeg,.png">

          <!-- Botón personalizado que activa el input oculto -->
          <label for="pedidosOxiFiles" class="custom-file-button">
            <i class="bi bi-cloud-upload me-2"></i>Adjuntar archivos
          </label>
        </div>

        <div class="form-text">Podés adjuntar todos los archivos juntos en formato PDF, JPG, PNG</div>
        @if (isInvalid('pedidosOxiFiles')) {
        <div class="text-danger-obligatorio">Debe adjuntar al menos un archivo</div>
        }

        <!-- Lista de archivos seleccionados -->
        @if (selectedFiles.pedidosOxiFiles.length > 0) {
        <div class="selected-files-card">
          <div class="selected-files-header">
            <small>Archivos seleccionados ({{selectedFiles.pedidosOxiFiles.length}})</small>
          </div>
          <div>
            @for (file of selectedFiles.pedidosOxiFiles; track file; let i = $index) {
            <div class="file-item">
              <div class="file-info">
                <i class="{{getFileIcon(file.name)}} file-icon"></i>
                <span>{{file.name}} <small class="text-muted">({{formatFileSize(file.size)}})</small></span>
              </div>
              <button type="button" class="btn-delete-file" (click)="eliminarArchivo('pedidosOxiFiles', i)"
                title="Eliminar archivo" style="font-size: 0.7rem; padding: 2px 5px;">
                <i class="bi bi-trash"></i>
              </button>
            </div>
            }
          </div>
        </div>
        }
      </div>

      <!-- Observaciones -->
      <div class="mb-3">
        <label for="observacionesOxi" class="form-label">Observaciones</label>
        <textarea class="form-control" id="observacionesOxi" formControlName="observacionesOxi" rows="3"></textarea>
        <div class="form-text">Si lo consideras necesario, podes registrar tus comentarios aquí</div>
      </div>
    </div>
    }
    @default {
    <!-- No mostrar nada si no se ha seleccionado un tipo -->
    }
    }

    <div class="mt-4">
      @if (loading) {
      <div class="progress mb-3">
        <div class="progress-bar progress-bar-striped progress-bar-animated" [style.width.%]="uploadProgress">
          {{uploadProgress}}%
        </div>
      </div>
      <button type="button" class="btn btn-primary" disabled>
        <span class="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
        Enviando solicitud...
      </button>
      } @else {
      <button type="submit" class="btn btn-primary" [disabled]="!esFormularioValido()">Enviar solicitud</button>
      }
    </div>
  </form>
</div>